export const APP_DRAWER_QUERY_KEY = 'drawer'
export const ENTITY_ID_QUERY_KEY = 'id'
export const NOTIFICATION_DRAWER_QUERY_VALUE = 'notification'
export const MAX_FILES_SIZE = 200
export const MAX_DESCRIPTION_LENGTH = 500
export const MAX_DESCRIPTION_LENGTH_MESSAGE_FROM = 1
export const MAX_COMMENT_LENGTH = 4096
export const MAX_COMMENT_LENGTH_MESSAGE_FROM = 4000
export const MODAL_TITLE_ERROR = 'Ошибка'
